import * as React from "react";
const SvgFiRrIslandTropical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-island-tropical_svg__a)">
      <path
        fill="#062147"
        d="M23.534 22.155c-.153-.097-2.928-1.824-7.035-2.68.418-1.801 1.217-6.164.28-10.145a38 38 0 0 0-.513-1.946c1.64.955 3.342 1.386 4.539 1.578q.153.025.304.024c.598 0 1.166-.282 1.53-.774.434-.583.505-1.35.188-2.003-.626-1.29-1.764-3.09-3.63-4.354C16.205-.172 12.498-.032 11.98 0c-.515-.01-4.164-.003-7.14 2.012-1.821 1.233-2.96 2.932-3.593 4.14a1.92 1.92 0 0 0 .146 2.03 1.9 1.9 0 0 0 1.856.77c.88-.145 2.04-.42 3.245-.943.024 1.03.2 1.994.396 2.649.174.58.598 1.033 1.165 1.244a1.9 1.9 0 0 0 1.697-.18c.696-.444 1.523-1.18 2.245-2.081l.003.36c0 3.844-1.838 7.832-2.504 9.149-5.182.61-8.854 2.894-9.031 3.006a1 1 0 1 0 1.068 1.69C1.572 23.82 6.998 21 11.998 21c5.868 0 10.422 2.818 10.467 2.846a1 1 0 1 0 1.067-1.691zM18.078 3.51c1.442.977 2.36 2.392 2.89 3.45-1.142-.2-2.75-.641-4.203-1.625-1.432-.97-2.447-2.29-3.072-3.287 1.225.125 2.937.48 4.384 1.46zM3.087 6.95c.539-.994 1.46-2.326 2.874-3.283 1.422-.963 3.084-1.372 4.299-1.544-.628.987-1.628 2.266-3.025 3.212-1.433.97-3.018 1.413-4.147 1.615zm5.687 3.02c-.22-.797-.367-2.04-.226-3.112 1.417-1.006 2.462-2.26 3.176-3.315.104.627.148 1.336.04 2.048l-.01.065a4.7 4.7 0 0 1-.23.882c-.57 1.54-1.947 2.886-2.751 3.433zM11.787 19C12.676 17.042 14 13.532 14 10a42 42 0 0 0-.2-3.748 34 34 0 0 1 1.032 3.535c.858 3.646.048 7.825-.314 9.364a22 22 0 0 0-2.52-.151q-.105 0-.211.002"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-island-tropical_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIslandTropical;
